import React, { ComponentProps } from 'react';
import { useSelector } from 'react-redux';
import { Checkbox as BaseCheckbox } from 'component-library-and-tools';

import { getThemeMode } from 'services/user/getters';

import { colorsByTheme, Theme } from 'lib/prisma-styles';

const Checkbox = ({
  ...props
}: ComponentProps<typeof BaseCheckbox>) => {
  const theme: keyof Theme = useSelector(getThemeMode);

  return (
    <BaseCheckbox
      {...props}
      color={colorsByTheme[theme].interactive.defaultBorder}
      colorWhenChecked={colorsByTheme[theme].interactive.primaryAction}
    />
  );
};

export default Checkbox;
